import { createSlice } from '@reduxjs/toolkit';

export const movingBoxSlice = createSlice({
  name: 'movingBox',
  initialState: {
    currBoxID: '',
    currSeatID: '',
    currBoxChatSid: '',
    currBoxName: '',
    newBoxID: '',
    newBoxName: '',
    newBoxChatSID: '',
    newSeatName: '',
  },
  reducers: {
    updateFirstWave: (state, action) => {
      const { newBoxID, newBoxName, newBoxChatSID } = action.payload;
      return {
        ...state,
        newBoxID: newBoxID,
        newBoxName: newBoxName,
        newBoxChatSID: newBoxChatSID,
      };
    },
    updateCurrBoxNSeat: (state, action) => {
      const { boxID, seatID, boxSid, boxName } = action.payload;
      return {
        ...state,
        currBoxID: boxID,
        currSeatID: seatID,
        currBoxChatSid: boxSid,
        currBoxName: boxName,
      };
    },
  },
});

export const { updateFirstWave, updateCurrBoxNSeat } = movingBoxSlice.actions;

export default movingBoxSlice.reducer;
